import { createErrorClass } from './createErrorClass';
export var ArgumentOutOfRangeError = createErrorClass(function (_super) {
    return function ArgumentOutOfRangeError() {
        _super(this);
        this.message = 'argument out of range';
    };
});
//# sourceMappingURL=ArgumentOutOfRangeError.js.map